import React from 'react';
import data from '../headerData';
import Slider from 'react-slick';
import { NavLink } from 'react-router-dom';

class Header extends React.PureComponent {
  state = {
    main: data.main,
    loadedSlides: { 0: true },
  }

  render() {
    const settings1 = {
      dots: true,
      infinite: true,
      speed: 900,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
      pauseOnHover: true,
      swipeToScroll: true,
      centerMode: false,
      centerPadding: '0px',
      arrows: false
    };
    const loadSlide = nextIndex => {
      this.setState(currentState => ({
        loadedSlides: {
          ...currentState.loadedSlides,
          [nextIndex]: true,
        },
      }));
    };
    return (
      <Slider {...settings1} beforeChange={(...args) => loadSlide(args[1])}>
        {Object.values(this.state.main).map((types, index) => 
          <div
            key={index}
            className="jumbotron menubanner"
            style={{
              backgroundImage: this.state.loadedSlides[index]
                ? "url('" + process.env.PUBLIC_URL + "/images/" + types.picture + "')"
                : 'none',
              height: "540px",
            }}
          >
            <div className="container bannerWrapper">
              <div className="bannerText">
                <h1 className="display-3">{types.title}</h1>
                <p className="lead underline">{types.body}</p>
                <div className="text-center marT">
                  <NavLink to={process.env.PUBLIC_URL + '/' + types.hash} exact activeClassName="active">
                    <button className="btn btn-outline-secondary btn-lg">{types.button}</button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div> 
          )
        }
      </Slider>
    )
  }
}

export default Header;
